import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BuilderPackages({ currentCompany }) {

  const [packages, setPackages] = useState([]);

  const filteredPackages = packages.filter(
    p => p.company_slug === currentCompany.slug
  );

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    const res = await axios.get(`${API}/packages`);
    setPackages(res.data);
  };

  return (
    <section className="py-28 bg-obsidian">

      <div className="max-w-7xl mx-auto px-6">

        <div className="text-center mb-16">

          <h2 className="text-4xl md:text-5xl font-heading text-white mb-4">
            {currentCompany.slug === "architecture"
              ? "Architecture Packages"
              : "Construction Packages"}
          </h2>

          <p className="text-gray-400 max-w-xl mx-auto">
            Choose the perfect package for your project.
          </p>

        </div>

        <div className="grid md:grid-cols-3 gap-10">

          {filteredPackages.map((pkg) => (

            <div
              key={pkg.id}
              className="relative group rounded-2xl overflow-hidden border border-white/10 bg-white/[0.02] backdrop-blur-xl transition duration-500 hover:-translate-y-3"
            >

              {/* Glow */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500 bg-gradient-to-b from-gold/20 via-transparent to-transparent blur-2xl"/>

              {/* Image */}
              <div className="overflow-hidden">
                <img
                  src={pkg.image_url}
                  alt={pkg.title}
                  className="w-full h-[260px] object-cover transition duration-700 group-hover:scale-110"
                />
              </div>

              {/* Content */}
              <div className="p-6 relative z-10">

                <h3 className="text-white text-2xl font-semibold mb-2">
                  {pkg.title}
                </h3>

                <p className="text-gold text-xl mb-4">
                  {pkg.price}
                </p>

                <p className="text-gray-400 text-sm mb-5">
                  {pkg.description}
                </p>

                <ul className="space-y-2">
                  {pkg.features?.map((f, i) => (
                    <li key={i} className="text-gray-300 text-sm flex items-start gap-2">
                      <span className="text-gold">•</span>
                      {f}
                    </li>
                  ))}
                </ul>

              </div>

              <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-gold to-transparent opacity-0 group-hover:opacity-100 transition"/>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}
